import { Alert, Anchor, Box, Center, Grid, Loader, Text } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import { IconInfoCircle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../Layout/Contexts/User/useUserContext";
import HomeTabs from "./Structure/HomeTabs";
import { HomeHeader } from "./Structure/HomeHeader";
import { useState } from "react";
import HomeLists from "./Structure/HomeLists";

export type PossibleTabs =
  | "Appointment"
  | "Callback"
  | "RecentLeads"
  | "ActiveCases"
  | "OpenLeads"
  | "Omnichannel";

const SURVEY_URL = "https://forms.gle/W2q52CvJmmswfovV9";
const SURVEY_VISIBLE_UNTIL = new Date("2026-05-28T00:00:00");
const SURVEY_DISMISSED_KEY = "surveyNotice_2026-05-27_dismissed";

export default function Home() {
  const { finalUser, isLoading: isLoadingUser } = useUserContext();
  const { t } = useTranslation("features");
  const [activeTab, setActiveTab] = useState<PossibleTabs | undefined>(
    undefined,
  );
  const [surveyDismissed, setSurveyDismissed] = useLocalStorage<boolean>({
    key: SURVEY_DISMISSED_KEY,
    defaultValue: false,
  });

  const showSurveyNotice =
    !surveyDismissed && new Date() < SURVEY_VISIBLE_UNTIL;

  if (isLoadingUser) {
    return (
      <Center mt={40}>
        <Loader />
      </Center>
    );
  }
  return (
    <Box ml={12} mt={16}>
      <Grid align="center" gutter="md">
        <Grid.Col span={{ base: 12, md: showSurveyNotice ? 6 : 12 }}>
          <HomeHeader username={finalUser?.name ?? ""} />
        </Grid.Col>
        {showSurveyNotice && (
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Alert
              icon={<IconInfoCircle size={20} />}
              color="amber"
              variant="light"
              radius="md"
              title={t("home.surveyTitle")}
              withCloseButton
              onClose={() => {
                setSurveyDismissed(true);
              }}
              styles={{
                root: { border: "1px solid var(--mantine-color-amber-4)" },
                title: { fontWeight: 600 },
              }}
            >
              <Text style={{ whiteSpace: "pre-line" }}>
                {t("home.surveyMessage")}
              </Text>
              <Anchor
                href={SURVEY_URL}
                target="_blank"
                rel="noopener noreferrer"
                fw={600}
              >
                {SURVEY_URL}
              </Anchor>
            </Alert>
          </Grid.Col>
        )}
      </Grid>
      <HomeTabs activeTab={activeTab!} setActiveTab={setActiveTab} />
      <HomeLists activeTab={activeTab!} />
    </Box>
  );
}
